import { DefectCodeDialog } from "./DefectCodeDialog";
import { FormikValues } from "formik";
import { Button } from "primereact/button";
import { useCallback, useState, MouseEvent } from "react";
import { FormInputText } from "../Shared/FormInputText";

type Props = {
    disabled: boolean;
    formik: FormikValues;
}

export const FormDefectCode = (props: Props) => {
    const { disabled, formik } = props;
    
    const [visible, setVisible] = useState(false);

    const onClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setVisible(true);
    }, [])

    const onSubmit = useCallback(async (typeCode: string | null, codeAssignReason?: string | null) => {
        formik.setFieldValue("typeCode", typeCode);
        if (codeAssignReason) {
            formik.setFieldValue("codeAssignReason", codeAssignReason);
        }
    }, [formik])

    const onHide = useCallback(() => {
        setVisible(false);
    }, []);

    return (
        <div className="flex justify-content-between">
            <div className="flex-1 mr-3">
                <FormInputText disabled={true} formik={formik} value="typeCode" label="Defect Code" data-cy="defect-code-input"/>
            </div>
            <div>
                <Button label="Assign Defect Code" onClick={onClick} disabled={disabled} data-cy="assign-defect-code-button"/>
            </div>
            <DefectCodeDialog 
                onSubmit={onSubmit} 
                visible={visible} 
                onHide={onHide} 
                currentTypeCode={formik.values.typeCode}
                data-cy="defect-code-dialog"
            />
        </div>
    );
}